const swiperElement = document.querySelector('.tickerSwiper');
const delay = swiperElement ? parseInt(swiperElement.dataset.delay, 10) : 5000;

const swiper = new Swiper('.tickerSwiper', {
  slidesPerView: 2,
  spaceBetween: 10,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: delay
  }
});

// Smoothly scroll to the review section when any rating star is clicked
// Handles multiple star elements (class: 'product-info__rating')
// Offsets scroll position by the header height (class: 'cc-header')
document.querySelectorAll('.product-info__rating').forEach((star) => {
  star.addEventListener('click', () => {
    const reviewSection = document.getElementById('judgeme_product_reviews');
    if (!reviewSection) return;

    const header = document.querySelector('.cc-header');
    const headerHeight = 56;

    const scrollToPosition =
      reviewSection.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    });
  });
});
